import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import SEO from './components/SEO';
import Navigation from './components/Navigation';
import PurchaseSuccess from './components/PurchaseSuccess';
import Hero from './components/Hero';
import Meetings from './components/Meetings';
import BeforeMeeting from './components/BeforeMeeting';
import LiveWorkspace from './components/LiveWorkspace';
import AfterMeeting from './components/AfterMeeting';
import SkillPhases from './components/SkillPhases';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Comparison from './components/Comparison';
import FounderNote from './components/FounderNote';
import Pricing from './components/Pricing';
import Faq from './components/Faq';
import CompanyInterest from './components/CompanyInterest';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Demo from './components/Demo';
import { initGA } from './utils/analytics';
import { logEnvironmentInfo } from './utils/environment';

// Route-level scroll reset: plain <BrowserRouter> does no scroll restoration
// of its own, so navigating legal page -> landing would land mid-page at the
// legal page's scroll offset. Keyed on pathname only — in-page anchor links
// (#pricing etc.) don't change the pathname, so smooth-scroll is unaffected.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Landing = () => (
  <>
    <SEO />
    <Navigation />
    <PurchaseSuccess />
    <main>
      <Hero />
      <Meetings />
      <BeforeMeeting />
      <LiveWorkspace />
      <AfterMeeting />
      <SkillPhases />
      <Features />
      <HowItWorks />
      <Comparison />
      <FounderNote />
      <Pricing />
      <Faq />
      <CompanyInterest />
      <Waitlist />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    initGA();
    if (process.env.NODE_ENV !== 'production') {
      logEnvironmentInfo();
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/demo" element={<Demo />} />
            {/* SPA fallback — unknown paths render the landing page. */}
            <Route path="*" element={<Landing />} />
          </Routes>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
